import { useEffect } from 'react';
import { Route, Routes, useNavigate, useParams } from 'react-router-dom';
import { DiagramEditor } from '../components/DiagramEditor';
import { diagramStore } from '../state/diagramStore';
import { DevicesPage } from './DevicesPage';

function EventsPage() {
  return (
    <div className="p-4 md:p-6">
      <h2 className="page-title">Події</h2>
      <div className="card mt-4">
        <p className="text-sm text-gray-600 dark:text-gray-300">Події зі зміною стану — фаза 3 (D1).</p>
      </div>
    </div>
  );
}

function HistoryPage() {
  return (
    <div className="p-4 md:p-6">
      <h2 className="page-title">Історія / метрики</h2>
      <div className="card mt-4">
        <p className="text-sm text-gray-600 dark:text-gray-300">Агрегати метрик — фаза 3. Версії схеми — у панелі редактора.</p>
      </div>
    </div>
  );
}

const RETIRED_SITE_IDS = new Set(['SITE-DEMO', 'SITE-PU']);

export function SitePage() {
  const { id = 'SITE-OFFICE-3F' } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (RETIRED_SITE_IDS.has(id)) {
      void navigate('/site/SITE-OFFICE-3F', { replace: true });
      return;
    }
    diagramStore.setSite(id);
  }, [id, navigate]);

  return (
    <div>
      <Routes>
        <Route index element={<DiagramEditor initialMode="monitor" />} />
        <Route path="edit" element={<DiagramEditor initialMode="edit" />} />
        <Route path="devices" element={<DevicesPage />} />
        <Route path="events" element={<EventsPage />} />
        <Route path="history" element={<HistoryPage />} />
      </Routes>
    </div>
  );
}
